import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CatalogoListadoComponent } from './componentes/catalogo-listado/catalogo-listado.component';
import { CotizarComponent } from './componentes/cotizar/cotizar.component';
import { CotizacionesClienteComponent } from './componentes/cotizaciones-cliente/cotizaciones-cliente.component';
import { CategoriasComponent } from './componentes/categorias/categorias.component';
import { PrecioTipoComponent } from './componentes/precio-tipo/precio-tipo.component';
import { MarcasComponent } from './componentes/marcas/marcas.component';
import { ModelosComponent } from './componentes/modelos/modelos.component';
import { MenuNuevoComponent } from './menu-nuevo/menu-nuevo.component';
import { VistaProductoComponent } from './componentes/vista-producto/vista-producto.component';

const routes: Routes = [
	{
		path: '',
		component: CategoriasComponent,
  	},
	{
		path: 'modelos',
		component: ModelosComponent,
  	},
	{
		path: 'menu-nuevo',
		component: MenuNuevoComponent,
  	},
	{
		path: 'marcas',
		component: MarcasComponent,
  	},
	{
		path: 'precio-tipo',
		component: PrecioTipoComponent,
  	},
	{
		path: 'catalogo',
		component: CatalogoListadoComponent,
  	},
	{
		path: 'catalogo/vendedor/:vendedor',
		component: CatalogoListadoComponent,
  	},
	{
		path: 'catalogo/vendedor/:vendedor/:modoPrecio',
		component: CatalogoListadoComponent,
  	},
	{
		path: 'catalogo/busqueda/:busqueda/:ordenar/:ordenarModo/:modoPrecio/:vendedor',
		component: CatalogoListadoComponent,
  	},
	{
		path: 'catalogo/busqueda/:busqueda/:ordenar/:ordenarModo/:modoPrecio',
		component: CatalogoListadoComponent,
  	},
	{
		path: 'cotizar',
		component: CotizarComponent,
  	},
	{
		path: 'cotizar/:cotizacion_id',
		component: CotizarComponent,
  	},
	{
		path: 'cotizaciones',
		component: CotizacionesClienteComponent,
  	},
	{
		path: 'catalogo/:modoPrecio',
		component: CatalogoListadoComponent,
  	},
	{
		path: 'producto',
		component: VistaProductoComponent,
  	},
	
	{
		path: 'vendedor/:vendedor/:modoPrecio',
		redirectTo: 'catalogo/vendedor/:vendedor/:modoPrecio',
		pathMatch: 'full'
	},
	{
		path: '**',
		component: CategoriasComponent
	}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
